var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInboundAnswer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2418_14375)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.667969 2.6665C0.667969 1.56193 1.5634 0.666504 2.66797 0.666504H5.2145L6.05833 4.88562L4.27723 6.66672C4.96779 9.10832 6.89282 11.0333 9.33442 11.7239L11.1155 9.94281L15.3346 10.7866V13.3332C15.3346 14.4377 14.4392 15.3332 13.3346 15.3332H11.3346C5.4436 15.3332 0.667969 10.5575 0.667969 4.6665V2.6665ZM2.66797 1.99984C2.29978 1.99984 2.0013 2.29831 2.0013 2.6665V4.6665C2.0013 9.82116 6.17998 13.9998 11.3346 13.9998H13.3346C13.7028 13.9998 14.0013 13.7014 14.0013 13.3332V11.8797L11.5538 11.3902L9.74781 13.1961L9.38817 13.1136C6.16406 12.3734 3.6277 9.83708 2.88756 6.61297L2.805 6.25333L4.61094 4.44739L4.12143 1.99984H2.66797Z",
    fill: "#697180"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2768 1.77863L11.5472 5.5082H13.476V7.00002H9.00049V2.52455H10.4923V4.45332L14.2219 0.723755L15.2768 1.77863Z",
    fill: "#16A24A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2418_14375"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInboundAnswer);
export default __webpack_public_path__ + "static/media/inbound_answer.2477bc1f724666f7025bf02e7e986df0.svg";
export { ForwardRef as ReactComponent };